// extracted by mini-css-extract-plugin
export default {"appsWrapper":"AppsWrapper-module--appsWrapper--af023"};